import { render, staticRenderFns } from "./obj.vue?vue&type=template&id=c1a85386&"
import script from "./obj.vue?vue&type=script&lang=js&"
export * from "./obj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports